import React from 'react';
import type { TemplateModel, WebsitePage } from '@troia-v3/types';
import { Icon } from '@/shared/icons';

interface PanelPagesProps {
  pages: WebsitePage[];
  model: TemplateModel;
  onOpenPage: (pageId: string) => void;
}

/** Lista de páginas do site: nome, rota e contagem de blocos visíveis. */
export const PanelPages: React.FC<PanelPagesProps> = ({ pages, model, onOpenPage }) => (
  <div className="space-y-1">
    {pages.map((page) => {
      const def = model.pages.find((p) => p.id === page.pageId);
      const visibleCount = page.blocks.filter((b) => b.visible).length;
      return (
        <button
          key={page.pageId}
          type="button"
          onClick={() => onOpenPage(page.pageId)}
          className="w-full flex items-center gap-2.5 px-2.5 py-2.5 rounded-lg transition-colors text-left"
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--theme-button-ghost-hover)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
          data-testid={`page-item-${page.pageId}`}
        >
          <Icon name="file-text" className="w-4 h-4 flex-shrink-0" style={{ color: 'var(--theme-muted-text)' }} />
          <span className="flex-1 min-w-0">
            <span className="block text-sm font-medium truncate" style={{ color: 'var(--theme-card-text)' }}>
              {def?.name || page.pageId}
            </span>
            <span className="block text-xs truncate" style={{ color: 'var(--theme-muted-text)' }}>
              {(def?.isDynamic ? def?.routePattern : def?.defaultRoute) || '/'}
              {def?.isDynamic ? ' · dinâmica' : ''} · {visibleCount} {visibleCount === 1 ? 'bloco' : 'blocos'}
            </span>
          </span>
          <Icon name="chevron-right" className="w-4 h-4 flex-shrink-0" style={{ color: 'var(--theme-muted-text)' }} />
        </button>
      );
    })}
  </div>
);
